export function getTransferCoordinates(
  latitude: string | number | null | undefined,
  longitude: string | number | null | undefined,
): { lat: number; lng: number } | undefined {
  if (latitude == null || longitude == null || String(latitude).trim() === '' || String(longitude).trim() === '') {
    return undefined
  }
  const lat = Number(latitude)
  const lng = Number(longitude)
  if (!Number.isFinite(lat) || Math.abs(lat) > 90 || !Number.isFinite(lng) || Math.abs(lng) > 180) {
    return undefined
  }
  return { lat, lng }
}
